// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EcWb","top":"styles_top__2Jm_O"};